import { Component, Input } from '@angular/core';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FormGroup } from '@angular/forms';
import { FieldBase } from '@nagel-types';

@Component({
    selector: 'lib-floating-action-button',
    imports: [
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './floating-action-button.component.html',
    styleUrl: './floating-action-button.component.scss'
})
export class FloatingActionButtonComponent extends BaseFieldComponent {
  @Input() override field!: FieldBase<unknown>;
  @Input() override form!: FormGroup;

  @Input() key: string = '';
  @Input() label: string = '';
  @Input() type: string = '';
  @Input() className: string = '';
  @Input() icon: string = '';
  @Input() variant: string = '';

  ngOnInit() {
      this.key = this.field?.key ?? this.key;
      this.label = this.field?.label ?? this.label;
      this.type = this.field?.type ?? this.type;
      this.className = this.field?.className ?? this.className;
      this.icon = this.field?.icon ?? this.icon;
      this.variant = this.field?.variant ?? this.variant;
  }

  getIsDisabled(): boolean {
      return this.form.controls[this.key]?.disabled;
  }
}